module.exports = __webpack_public_path__ + "components/weather-icon/static/nightsnowshowers@3-ded0879700eeb34f4a1e33e050cf9768.png";